define('taoProctoring/controller/routes',{
    'Reporting' : {
        'actions' : {
            'index' : 'controller/Reporting/history'
        }
    },
    'Irregularity' : {
        'actions' : {
            'index' : 'controller/Irregularity/index'
        }
    },
    'DeliverySelection' : {
        'actions' : {
            'index' : 'controller/Delivery/index'
        }
    },
    'Monitor' : {
        'actions' : {
            'index' : 'controller/Delivery/monitoring'
        }
    },
    'Tools' : {
        'css': 'tools',
        'actions' : {
            'assessmentActivity' : 'controller/Tools/assessmentActivity'
        }
    }
});

